enum PermissionCluster {
  AccountDetails = 'AccountDetails',
  Balances = 'Balances',
  Transactions = 'Transactions',
  DirectDebits = 'DirectDebits',
  StandingOrders = 'StandingOrders'
}

export default PermissionCluster;
